module.exports = __webpack_public_path__ + "img/VetoSansCond-BoldItalic.76f4f58f.svg";